
import * as appsettings from "../appsettings";
import * as main from "../main";


let LABEL_YES = "";
let LABEL_NO = "";
let LABEL_DELETE = "";

function removeSelectedCapcodes() {

    let selectedIds = [];

    let listBox = $("#CapcodesSelected").data("kendoListBox");
    let allItems = listBox.items();
    let selectedItems = listBox.select();

    if (selectedItems.length > 0) {

        for (let i = 0; i < selectedItems.length; i++) {
            let index = allItems.index(selectedItems[i]);
            let item = listBox.dataSource.view()[index];
            selectedIds[i] = parseInt(item.Value);
        }
    }

    let list = selectedIds.slice();

    $.ajax({
        type: "POST",
        url: appsettings.getUrl("NodeCapcode/RemoveCapCodes"),
        data: {
            list: kendo.stringify(list)
        },
        dataType: 'json',
        success: function (responseData: response | undefined | null) {

            // refresh listbox
            var lb = $("#CapcodesSelected").data("kendoListBox");

            if (responseData != undefined && responseData != null) {
                if (responseData.state.Succesfully) {
                    lb.dataSource.data(responseData.data)

                    var btnDelete = document.getElementById("delete-button");
                    btnDelete.setAttribute("disabled", "disabled");
                }
                else {
                    main.makeResultMessage(responseData.state);
                }
            }
        }
    });
}


export function initialize(label_yes: string, label_no: string, label_delete: string): void {
    LABEL_YES = label_yes;
    LABEL_NO = label_no;
    LABEL_DELETE = label_delete;
}

export function deleteButtonClicked(): void {
    main.openActionsDialog(' ', LABEL_DELETE,
        [{ text: LABEL_YES, action: function () { removeSelectedCapcodes(); main.closePopup(); } },
         { text: LABEL_NO, action: function () { main.closePopup(); }, primary: true }]);
}

export function addButtonClicked(): void {
    main.makeResultMessage(null);       // clear

    const tb = $("#capcode").data("kendoNumericTextBox");

    const capcode = tb.value();

    $.ajax({
        type: "POST",
        url: appsettings.getUrl("NodeCapcode/AddCapCode"),
        data: {
            capcode: capcode
        },
        dataType: 'json',
        success: function (responseData: response | undefined | null) {

            // refresh listbox
            const lb = $("#CapcodesSelected").data("kendoListBox");

            if (responseData != undefined && responseData != null) {
                if (responseData.state.Succesfully) {
                    lb.dataSource.data(responseData.data);

                    $("#capcode").data("kendoNumericTextBox").value(null);      // clear

                    const btnAdd = document.getElementById("add-button");
                    btnAdd.setAttribute("disabled", "disabled");
                }
                else {
                    main.makeResultMessage(responseData.state);
                }
            }

        }
    });
}

export function onNumTextBoxChanged(): void {
    main.makeResultMessage(null);       // clear

    const btnAdd = document.getElementById("add-button");
    btnAdd.removeAttribute("disabled");
}

export function onListBoxSelect(): void {
    const btnDelete = document.getElementById("delete-button");
    btnDelete.removeAttribute("disabled");
}
